import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import useShop from "./useShop.hook";
import useShopList from "./useShopList.hook";
import { ShopUserType } from "../types/shop";

export default function useBlockRetailUser() {
  const router = useRouter();
  const { userShopRole, selectedShop } = useShop();
  const shopListQuery = useShopList();
  const [redirected, setRedirected] = useState(false);

  useEffect(() => {
    if (router.pathname === "/login" || router.pathname.startsWith("/login/") || router.pathname === "/noShop") {
      return;
    }

    if (!shopListQuery.isFetched) {
      return;
    }

    if (shopListQuery.data?.length === 0) {
      router.push("/noShop");
    }
  }, [userShopRole, router, redirected, shopListQuery.isFetched, shopListQuery.data?.length, selectedShop]);
}
